import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import {
  useBackgroundDispatch,
} from 'src/hooks'
import { Rdrct } from 'src/navigation/Lnk'
import { cardsPhysicalCardsUrl } from 'src/navigation/urls'
import { createSetIsSetupOrganizationPopupOpen } from 'src/redux/actions/app.actions'
import {
  selectIsConfirmOrgModalAccountAccountsDismissed,
  selectIsUserOrglessRCNOwner,
} from 'src/redux/selectors/auth.selectors'

const AccountsAccounts: React.FC = () => {
  const isUserOrglessRCNOwner = useSelector(selectIsUserOrglessRCNOwner)
  const isConfirmOrgModalAccountAccountsDismissed = useSelector(
    selectIsConfirmOrgModalAccountAccountsDismissed,
  )
  const dispatch = useBackgroundDispatch()

  useEffect(() => {
    if (!!isUserOrglessRCNOwner && !isConfirmOrgModalAccountAccountsDismissed) {
      dispatch(createSetIsSetupOrganizationPopupOpen(true))
    }
  }, [isUserOrglessRCNOwner])

  return (
    <Rdrct to={cardsPhysicalCardsUrl()} />
  )
}

export default AccountsAccounts
